/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019-2021 (original work) Open Assessment Technologies SA
 *
 */

import config from '@/config';
import { getRolesGuard } from './guards/rolesGuard';
import {
    ROLE_WORKFLOW_USER,
    ROLE_LTI_USER
} from '../services/authService';

/**
 * @callback Controller
 * @returns {Promise}
 */

/**
 * @typedef Route
 * @property {string} path Abstract path that match to url
 * @property {Controller} controller
 * @property {import('./guards/rolesGuard').Guard} guard
 */

/**
 * @var Route[]
 */
const routeTable = [
    {
        path: config.routes.launch,
        controller: () => import(`../controller/launch/launch`)
    },

    // Task
    {
        path: config.routes.task,
        guard: getRolesGuard([ROLE_WORKFLOW_USER, ROLE_LTI_USER]),
        controller: () => import('@/controller/taskpage/taskpage')
    },
    {
        path: config.routes.ltiError,
        controller: () => import('@/controller/ltiError/lti-error')
    },
    {
        path: config.routes.taskNotFoundError,
        controller: () => import('@/controller/taskNotFoundError/task-not-found-error')
    },
    {
        path: config.routes.ltiSubmitted,
        controller: () => import('@/controller/ltiSubmitted/lti-submitted')
    },
    // Default (error)
    {
        path: '(.*)',
        controller: () => import('@/controller/error/error')
    }
];

export default routeTable;
